import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { combineLatest, Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AppState, ResponsiveTarget } from '@immosky/types';
import {
  ResponsiveService,
  selectIsMapVisible,
  selectResponsiveTarget,
  setIsMapVisible,
} from '@immosky/object-search-layout';
import { ScrollBlockingService } from '@immosky/shared';

@Component({
  selector: 'app-mobile-map-toggle',
  templateUrl: './mobile-map-toggle.component.html',
  styleUrls: ['./mobile-map-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileMapToggleComponent implements OnInit, OnDestroy {
  private subscription!: Subscription;

  isVisible = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>,
    private scrollBlockingService: ScrollBlockingService,
    private responsiveService: ResponsiveService
  ) {}

  ngOnInit(): void {
    this.subscription = combineLatest([
      this.store.pipe(select(selectIsMapVisible)),
      this.store.pipe(select(selectResponsiveTarget)),
    ]).subscribe(
      ([isVisible, responsiveTarget]: [boolean, ResponsiveTarget]) => {
        if (this.isVisible !== isVisible) {
          window.scrollTo(0, 0);
        }

        this.isVisible = isVisible;

        if (
          isVisible &&
          this.responsiveService.target(
            ResponsiveTarget.XS,
            ResponsiveTarget.SM
          )
        ) {
          this.scrollBlockingService.block();
        } else {
          this.scrollBlockingService.unblock();
        }

        this.cdRef.markForCheck();
      }
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setMapVisible(isVisible: boolean) {
    this.store.dispatch(
      setIsMapVisible({
        isMapVisible: isVisible,
      })
    );
  }
}
